export default "__VITE_ASSET__CmgAf_zY__"